import React from 'react';
import sanitizeHtml from 'sanitize-html';

const EmailObfuscationWrapper = ({ children }) => {
  const cleanedChildren = sanitizeHtml(
    children
      ?.replace(/<([^>]+)>\s*(&nbsp;\s*)*/g, '<$1>') // Remove any number of &nbsp; after opening tags
      ?.replace(/>\s*(&nbsp;\s*)*</g, '><')
  );
  return (
    <span
      suppressHydrationWarning
      dangerouslySetInnerHTML={{
        __html: `<!--email_off-->${cleanedChildren}<!--/email_off-->`,
      }}
    />
  );
};

export default EmailObfuscationWrapper;
